(function($) {
    $.widget("ca.caColorPicker", {

        _create : function() {
            var colorPicker = this.element;     
            $(colorPicker).colorpicker({format: 'hex'});
        }
    });
})(jQuery);
